/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Branchen_Kennenlernen31Inputs */

const en__field_enum_csjensblank_branchen_kennenlernen31 = /** @type {(inputs: _Field_Enum_Csjensblank_Branchen_Kennenlernen31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know other industries`)
};

const de__field_enum_csjensblank_branchen_kennenlernen31 = /** @type {(inputs: _Field_Enum_Csjensblank_Branchen_Kennenlernen31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branchen und Tätigkeitsfelder kennenlernen`)
};

/**
* | output |
* | --- |
* | "Get to know other industries" |
*
* @param {_Field_Enum_Csjensblank_Branchen_Kennenlernen31Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_branchen_kennenlernen31 = /** @type {((inputs?: _Field_Enum_Csjensblank_Branchen_Kennenlernen31Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Branchen_Kennenlernen31Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_branchen_kennenlernen31(inputs)
	return de__field_enum_csjensblank_branchen_kennenlernen31(inputs)
});
export { _field_enum_csjensblank_branchen_kennenlernen31 as "_field_enum_CSJENSBLANK_BRANCHEN_KENNENLERNEN" }